import ColescbaApp from '@colescba/app-vue'
import ColescbaAuthVue from '@colescba/auth-vue'
import ColescbaUI from '@colescba/ui'

const plugins = {
  auth: ColescbaAuthVue,
  ui: ColescbaUI,
}

const features = {
  delegacion: true,
  padAplicaciones: true,
  notificaciones: true,
  acreditadorNuevo: true,
}

import { Datetime } from 'vue-datetime'
import { Settings } from 'luxon'
Settings.defaultLocale = 'es'

import VueToast from 'vue-toast-notification'

import VueBarcode from 'vue-barcode'

export default {
  // eslint-disable-next-line no-unused-vars
  install(Vue, options) {
    Vue.use(ColescbaApp, { env: process.env, plugins, features })

    Vue.component('datetime', Datetime)

    Vue.use(VueToast, {
      position: 'top',
    })

    Vue.component('barcode', VueBarcode)
  },
}
